var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input_file",class:_vm.classList,style:(_vm.styleStr),attrs:{"type":"file","name":_vm.name,"id":_vm.id,"accept":_vm.accept,"capture":_vm.capture,"files":_vm.files},on:{"change":function($event){return _vm.selectFiles($event)}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9ae55a7e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FileStorageUpload.vue
// module id = null
// module chunks = 